
<div class="ticker">
  <div class="label">
    Latest
  </div>
  <div class="items">
    <a :href="item.url" class="item" v-for="(item, index) in items" :key="index" :ref="`item-${index}`" :id="`item-${index}`"  :class="index == active ? 'active' : ''">
      {{ item.title }}
    </a>
  </div>
  <div class="overlay" ref="overflow"></div>
</div>
